///**
// * Стандартные провайдеры аутентификации. 
// * @readonly
// * @global
// * @enum {string} STD_AUTH_PROVIDERS 
// * @example  
//*/
window.STD_AUTH_PROVIDERS = {
  WINDOWS: 'windows',
  SQL: 'sql',
  NOVELL: 'novell',
  CURRENT: 'current'
};

///**
// * Варианты результата аутентификации. 
// * @readonly
// * @global
// * @enum {string} AUTH_REQUEST_RESULT 
// * @example  
//*/
window.AUTH_REQUEST_RESULT = {
  DONE: 0,
  CHANGE_DEFAULT_PASSWOD: 1,
  SHOW_LOGON_MESSAGE: 2
};

/**
* Удялет куку UserStatus после открытия страницы входа, что она не сохранялась при закрытии браузера в режиме сохранения последних открытых вкладок.
*/
function RemoveUserStatusCookie() {
  //Очищаем cookie со статусом пользователя
  if ($.cookie('UserStatus') === 'logout') {
    $.cookie('UserStatus', null, { path: '/' });
    $.cookie('UserStatus', null, { path: '/pda' });
  }
}

/**
* Проводит аутентификацию пользователя через сервис Authentication.
*/
function LoginUser(providerName, userName, userRealm, userPassword, rememberMe, changePasswordCallback, showMessageCallback, showErrorCallback) {
  var mobileView = WA.isMobile();
  var returnUrl = (new WA.URL()).getParam('ReturnUrl');
    
  var loginFunc = function () {
    WA.services.authenticaion.loginUser(providerName, userName, userRealm, userPassword, rememberMe,
        function (res) {
          switch (res.Result) {
            case AUTH_REQUEST_RESULT.CHANGE_DEFAULT_PASSWOD:
              //Необходимо сменить пароль
              if (changePasswordCallback)
                changePasswordCallback(res.Warning);
              break;

            case AUTH_REQUEST_RESULT.SHOW_LOGON_MESSAGE:
              //Отображаем сообщение о входе
              if (showMessageCallback)
                showMessageCallback(res.Warning);
              break;

            default:
              //Вход успешен, переходим на страницу по умолчанию,  либо returnUrl
              window.location.href = (returnUrl == '') ? g_defaultPage : returnUrl;
          }
        }, function (res) {
          //Аутентификация завершилась ошибкой
          if (showErrorCallback)
            showErrorCallback(res.Error);
        });
  };

  if (providerName == STD_AUTH_PROVIDERS.CURRENT) {
    //Пользователь уже аутентифицирован, можно просто перейти на страницу по умолчанию,  либо returnUrl
    window.location.href = (returnUrl == '') ? g_defaultPage : returnUrl;
  } else {
    if (mobileView) {
      loginFunc();
    } else {
      WA.AgentInit.done(function () {
        loginFunc();
      });
    }
  }
}

/**
* Изменяет пароль пользователя.
*/
function ChangeUserPassword(providerName, userName, oldPassword, newPassword, confirmPassword, isFirstLogin, successCallback, showErrorCallback) {
      WA.services.authenticaion.changePassword(userName, oldPassword, newPassword, confirmPassword, isFirstLogin,
      function (res) {
        if (successCallback)
          successCallback(res.Warning);
      }, function (res) {
        if (showErrorCallback)
          showErrorCallback(res.Error);
      });  
}